import { ID } from "../core/id";

export enum OrderStatus {
  INIT = "init", // Создан
  MODAR = "modar", // Модерация
  STEP_1 = "step_1", // Создан (шаг 1)
  STEP_2 = "step_2", // Создан (шаг 2)
  STEP_3 = "step_3", // Создан (шаг 3)
  STEP_4 = "step_4", // Создан (шаг 4)
  WORK = "work", // В работе
  NO_WORK = "no_work", // Проблемы
  NO_NOTES = "no_notes", // Нет объявлений
  CLOSE = "close", // Выполнен
  NO_CLOSE = "no_close", // Устарело
  PAUSE = "pause", // Приостановлен
}

export interface Order {
  // 🔑 Основные поля
  id: ID;
  client_id: ID;
  place_id: ID;
  number: number;
  // 📝 Контент
  url: string;
  title_url: string;
  description: string;
  status: OrderStatus;
  hours: number;
  // ⏰ Временные метки
  date_modified: number;
  date_published: number;
  client: OrderDataClient;
}

export interface OrderDataClient {
  name_order: string;
  support: string;
}

export interface OrderFront extends Order {
  job_complite: number;
  job_count: number;
  price: number;
  count: number;
}

export const ORDER_STATUS_MAP = {
  [OrderStatus.INIT]: "Ожидает оплаты",
  [OrderStatus.MODAR]: "Модерация",
  [OrderStatus.STEP_1]: "Создан (шаг 1)",
  [OrderStatus.STEP_2]: "Создан (шаг 2)",
  [OrderStatus.STEP_3]: "Создан (шаг 3)",
  [OrderStatus.STEP_4]: "Создан (шаг 4)",
  [OrderStatus.WORK]: "Выполняется",
  [OrderStatus.NO_WORK]: "Есть проблемы",
  [OrderStatus.NO_NOTES]: "Нет объявлений на Авито",
  [OrderStatus.CLOSE]: "Выполнен",
  [OrderStatus.NO_CLOSE]: "Выполняется",
  [OrderStatus.PAUSE]: "Приостановлен",
};
export const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
  [OrderStatus.INIT]: "error",
  [OrderStatus.MODAR]: "error",
  [OrderStatus.STEP_1]: "error",
  [OrderStatus.STEP_2]: "error",
  [OrderStatus.STEP_3]: "error",
  [OrderStatus.STEP_4]: "error",
  [OrderStatus.WORK]: "info",
  [OrderStatus.NO_WORK]: "warning",
  [OrderStatus.NO_NOTES]: "warning",
  [OrderStatus.NO_CLOSE]: "sucess",
  [OrderStatus.PAUSE]: "info",
  [OrderStatus.CLOSE]: "success",
};